import React from 'react';
import { Modal, FormGroup, ControlLabel, FormControl, Button, Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { MediaPreview } from '../mediaPreview';
import { Repositories } from '../../constants/repositories';
import { Languages } from '../../constants/languages';

export const AddSceneMediaModal = ({show, hide, scene, data, previewURL, updated, submitted}) => {
    return (
        <Modal show={show} onHide={hide}>
            <Modal.Header closeButton>
                <Modal.Title>Add New Media to {scene}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form horizontal onSubmit={submitted}>
                    <h4>Source</h4>
                    {formTextField('Path', 'A path for the media in your chosen Repository', updated, data.pathValidation)}
                    {formOptionsField('Repository', Repositories, updated, data.repositoryValidation)}

                    {mediaPreview(previewURL)}

                    <hr/>

                    <h4>Scene</h4>
                    {formTextField('Media Name', 'The name of the file in the post-processing directory', updated, data.mediaNameValidation)}
                    {formTextField('Dataset', 'The dataset number for the post-processed file', updated, data.datasetValidation)}
                    {formOptionsField('Language', Languages, updated, data.languageValidation)}

                    <hr/>

                    <Button type="submit" bsStyle="success" block disabled={!data.formValid}>Create</Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

const formTextField = (label, placeholder, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl type='text' name={label} placeholder={placeholder} onChange={onChange} />
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOptionsField = (label,  options, onChange, validation) => {
    return (
        <FormGroup controlId={`formHorizontal${label}`} validationState={validation}>
            <Col componentClass={ControlLabel} sm={3}>{label}</Col>
            <Col sm={9}>
                <FormControl componentClass='select' name={label} onChange={onChange} defaultValue=''>
                    <option value='' disabled/>
                    {Object.entries(options).map(formOption)}
                </FormControl>
                <FormControl.Feedback />
            </Col>
        </FormGroup>
    );
};

const formOption = kvp => {
    return (<option key={kvp[0]} value={kvp[0]}>{kvp[1]}</option>);
};

const mediaPreview = previewURL => {
    return previewURL !== ''
        ? (<MediaPreview mediaURL={previewURL} noPreviewMessage='There is no preview avaliable for this filetype.' />)
        : null;
};

AddSceneMediaModal.propTypes = {
    show:       PropTypes.bool.isRequired,
    hide:       PropTypes.func.isRequired,
    scene:      PropTypes.string.isRequired,
    previewURL: PropTypes.string.isRequired,
    data:       PropTypes.object.isRequired,
    updated:    PropTypes.func.isRequired,
    submitted:  PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/addSceneMediaModal/AddSceneMediaModal.js